export const SKIN_TONES = {
    light: '#ffdbb7',
    mediumLight: '#E8BA8F',
    medium: '#c88d61',
    mediumDark: '#A56134',
    dark: '#5d4437'
};
//# sourceMappingURL=skin-tones.js.map